module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-05.af4f491e.svg";